import { useState, useEffect, useRef } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';

import uuid from "react-uuid"
import styled from 'styled-components';

import Ckeditor from '../components/Ckeditor';

function Edit() {
    const today = new Date();
    const [data, setData] = useState({
        TITLE: '',
        COVER_IMAGE: '',
        CONTENT: '',
        CATEGORY_ID: 0,
        RELEASE_DATE:
            today.getFullYear() +
            '-' +
            ('0' + (today.getMonth() + 1)).slice(-2) +
            '-' +
            ('0' + today.getDate()).slice(-2),
        VIEWS: 0,
    });
    const params = useParams();
    const CoverRef = useRef();

    const [title, setTitle] = useState(data['TITLE']);
    const [cover, setCover] = useState(data['COVER_IMAGE']);
    const [content, setContent] = useState(data['CONTENT']);
    const [category, setCategory] = useState(data['CATEGORY_ID']);

    const [navList, setNavList] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        if (params.id !== 'new') {
            fetch('https://api.kerbo.co.kr/article/' + params.id + '?e=1', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then((res) => {
                if (res.ok) {
                    res.json().then((data) => {
                        setData(data);
                    });
                }
            });
        }
    }, [params.id]);

    useEffect(() => {
        fetch('https://api.kerbo.co.kr/categories', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((res) => {
            if (res.ok) {
                res.json().then((data) => {
                    setNavList(data);
                });
            }
        });
    }, []);

    useEffect(() => {
        setTitle(data['TITLE']);
        setCover(data['COVER_IMAGE']);
        setContent(data['CONTENT']);
        setCategory(data['CATEGORY_ID']);
    }, [data]);

    const titleOnchange = (e) => {
        setTitle(e.target.value);
    };

    const coverOnclick = (e) => {
        if (window.confirm("랜덤 이미지를 삽입하시겠습니까?")) {
            e.preventDefault();

            fetch('https://api.unsplash.com/photos/random?client_id=gGlPjK6svzdAV-TAA92gSpu0WYVAJefnlmo3hcJ2HSE&orientation=landscape&topics=bo8jQKTaE0Y', {
                    method: 'GET',
                }).then((res) => {
                    if (res.ok) {
                        res.json().then((data) => {
                            setCover(data['urls']['regular'] + "&w=1920");
                        })
                    }
                });
        }
    }

    const coverOnchange = (e) => {
        const file = CoverRef.current.files[0];

        const body = new FormData()
        body.append('file', file)

        fetch('https://api.kerbo.co.kr/upload/image?ai=' + window.sessionStorage.getItem('aid') + '&ac=' + window.sessionStorage.getItem('authcode'), {
                method: 'POST',
                body: body,
            }).then((res) => {
                if (res.ok) {
                    res.json().then((data) => {
                        setCover(data['url']);
                    })
                }
            });
    };

    const categoryOnchange = (e) => {
        setCategory(e.target.value);
    };

    const save_article = () => {
        if (!title || !content || !cover || !category) {
            alert("모든 내용을 입력해주세요.");
            return false;
        }

        const origin = {
            title: data['TITLE'],
            content: data['CONTENT'],
            cover_image: data['COVER_IMAGE'],
            category_id: data['CATEGORY_ID']
        }

        let body = {
            title: title,
            content: content,
            cover_image: cover,
            category_id: category
        };

        if (JSON.stringify(origin) === JSON.stringify(body)) {
            alert("변경된 내용이 없습니다.");
            return false;
        }

        if (params.id === "new") {
            fetch('https://api.kerbo.co.kr/article/new?ai=' + window.sessionStorage.getItem('aid') + '&ac=' + window.sessionStorage.getItem('authcode'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            }).then((res) => {
                if (res.ok) {
                    if (!window.confirm('삽입 완료.\n글 목록으로 이동하시겠습니까?')) {
                        navigate(0);
                        return false;
                    }

                    navigate('/', {replace: true});
                }
            });
        } else {
            fetch('https://api.kerbo.co.kr/article/' + params.id + '?ai=' + window.sessionStorage.getItem('aid') + '&ac=' + window.sessionStorage.getItem('authcode'), {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            }).then((res) => {
                if (res.ok) {
                    if (!window.confirm('수정 완료.\n글 목록으로 이동하시겠습니까?')) {
                        navigate(0);
                        return false;
                    }

                    navigate('/');
                }
            });
        }
    };

    return (
        <EditWrap>
            <Card>
                <ArticleInfoSection>
                    <ImageSection>
                        <label htmlFor="file">
                            <CoverImage src={ !cover ? '/img/add_article.jpg' : cover} />
                        </label>
                        <CoverInput
                            type="file"
                            accept="image/*"
                            id="file"
                            ref={CoverRef}
                            onClick={coverOnclick}
                            onChange={coverOnchange}
                        />
                    </ImageSection>
                    <TextSection>
                        <TitleInput
                            type="text"
                            defaultValue={title}
                            onChange={titleOnchange}
                            placeholder="글 제목"
                        ></TitleInput>
                        <SampleText dangerouslySetInnerHTML={{__html : content.replace(/(<([^>]+)>)/gi, '').substring(0, 200)}}></SampleText>
                    </TextSection>
                    <InfoSection>
                        <Info>
                            카테고리
                            <br />
                            <CategorySelect onChange={categoryOnchange} key={uuid()} defaultValue={category}>
                                <option
                                    value={0}
                                    disabled
                                >
                                    선택 필요
                                </option>
                                {navList.map((navData, idx) => (
                                    <option
                                        key={navData['CATEGORY_ID']}
                                        value={navData['CATEGORY_ID']}
                                    >
                                        {navData['CATEGORY_NAME']}
                                    </option>
                                ))}
                            </CategorySelect>
                        </Info>
                        <Info>
                            게시일
                            <br />
                            {data['RELEASE_DATE']}
                        </Info>
                        <Info>
                            조회수
                            <br />
                            {data['VIEWS']}
                        </Info>
                    </InfoSection>
                </ArticleInfoSection>
                <ButtonSection>
                    <Link to="#" onClick={save_article}>
                        작성 완료
                    </Link>
                </ButtonSection>
            </Card>
            <EditorSection>
                <Ckeditor
                    content={content}
                    setContent={setContent}
                    viewportTopOffset={165}
                />
            </EditorSection>
        </EditWrap>
    );
}

export default Edit;

const EditWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 22px;

    margin: 0px 160px 40px;
    box-sizing: border-box;
    min-width: 1035px;
`;

const Card = styled.article`
    width: 100%;

    height: 130px;
    background-color: #f2f2f2;

    border-radius: 10px;
    overflow: hidden;

    font-size: 16px;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
`;

const ArticleInfoSection = styled.section`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;

    min-width: 806px;
`;

const ImageSection = styled.section`
    width: 240px;

    flex-shrink: 0;
`;

const CoverImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;

    cursor: pointer;

    &:hover {
        /* 호버 css 작성하기 */
    }
`;

const CoverInput = styled.input`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
`;

const TextSection = styled.section`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    flex-shrink: 1;
    gap: 12px;

    width: 300px;
    margin-left: 18px;
    padding: 16px 0px 10px;
`;

const SampleText = styled.p`
    line-height: 18px;
    line-height: 20px;
    
    cursor: default;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
`;

const InfoSection = styled.section`
    padding: 46px 0px;
    margin-left: 48px;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: 59px;

    cursor: default;
`;

const Info = styled.p`
    line-height: 20px;
`;

const CategorySelect = styled.select`
    border: none;
    border-radius: 4px;

    width: 100px;
    height: 20px;

    background-color: #bebebe;

    font-size: 16px;
    color: #323232;

    cursor: pointer;
`;

const ButtonSection = styled.section`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: 26px;

    padding: 55px 0px;
    margin-right: 40px;
    margin-left: 48px;
`;

const TitleInput = styled.input`
    height: 24px;
    border: none;
    border-bottom: 2px solid #464646;
    background-color: inherit;
    outline: none;

    font-size: 20px;
    line-height: 24px;
`;

const EditorSection = styled.section`
    height: 100%;
`;
